import Handlebars from "handlebars/runtime";
import moment from 'moment';
import flatpickr from 'flatpickr';
import GalaxyApi from "../services/GalaxyApi";
import InputCounter from "./InputCounter";
import TimeConvert from "../helpers/timeConvert";

// Templates
import TicketsTpl from "../handlebars/TicketsResidents.handlebars";
import ArriveDateTpl from "../handlebars/ArrivalDate.handlebars";
import AddOnTpl from "../handlebars/Addon.handlebars";
import ArrivalTimeTpl from "../handlebars/ArrivalTime.handlebars";
import ArrivalTimeAllDayTpl from "../handlebars/AllDayArrivalTime.handlebars";
import ParkingTpl from "../handlebars/Parking.handlebars";
import TicketInsuranceTpl from "../handlebars/TicketInsurance.handlebars";

Handlebars.registerHelper("toStandardTime", (timeIn24hr) => {
  const time = TimeConvert.convertFrom24To12Format(timeIn24hr);
  const [hours, minutes, period] = time.match(/([0-9]{1,2}):([0-9]{2}) (AM|PM)/).slice(1);
  return `${hours}:${minutes}<span class="timeslot__meridian"> ${period}</span>`;
});

const BuyTickets = (() => {
  const DOM = {};
  const lateEntryStartTime = (new Date()).setHours(14, 30, 0, 0);
  let date = '';
  let visitors = [];
  let totalVisitors = 0;
  let extras = [];
  let totalExtras = 0;
  let bookingProtection = [];
  let totalTicketsToProtect = 0;
  let totalExtrasToProtect = 0;
  let totalTicketsProtected = 0;
  let totalExtrasProtected = 0;
  let visitorFrmData = '';
  let addOnFrmData = '';
  let parkingFrmData = '';
  let bookingProtectionFrmData = '';
  let arrivalDate = '';
  let arrivalTime = '';
  let eventId = '';
  let skipAddons = true;

  const ticketProtectionPLU = 'XXX';
  const addOnProtectionPLU = 'XXX';
  const ticketsProtectedPlus = [
    'XXX',
    'XXX',
    'XXX'
  ];
  const parkingPLU = 'PANAN01';

  const cacheDOM = () => {
    DOM.buyTicketsComponent = document.getElementById('resident-buy-tickets');
  };

  const hasFromPriceTicketInPackage = () => {
    return visitors.some(e => e.plu === 'GAADN001');
  }

  const updateTicketSelections = () => {
    // Tickets
    const ticketFormElem = document.getElementById('frm-ticket-selection');
    if (ticketFormElem) {
      const ticketFormData = new FormData(ticketFormElem);
      visitorFrmData = ticketFormData;
      visitors = [];
      totalVisitors = 0;

      for (const ticketFrmEntry of visitorFrmData.entries()) {
        let ticketName = ticketFrmEntry[0];
        let ticketValue = parseInt(ticketFrmEntry[1]);
        let ticketPLU = ticketFormElem.elements[ticketName].dataset['plu'];

        if (ticketValue > 0) {
          visitors.push({
            plu: ticketPLU,
            qty: ticketValue,
          });
          totalVisitors += ticketValue;
        }
      }
    }

    // Arrival date
    const arrivalDateFormElem = document.getElementById('frm-arrival-date');
    if (arrivalDateFormElem) {
      const arrivalDateFormData = new FormData(arrivalDateFormElem);
      arrivalDate = arrivalDateFormData.get('date');
    }

    // Arrival time
    const arrivalTimeFormElem = document.getElementById('frm-arrival-time');
    if (arrivalTimeFormElem) {
      const arrivalTimeFormData = new FormData(arrivalTimeFormElem);
      arrivalTime = arrivalTimeFormData.get('time');
      eventId = document.querySelector('input[name="time"]:checked').getAttribute('data-event-id');
    }

    // AddOns
    const addOnFormElem = document.getElementById('frm-addon');
    if (addOnFormElem) {
      const addOnFormData = new FormData(addOnFormElem);
      addOnFrmData = addOnFormData;
      totalExtras = 0;
      extras = [];

      for (const addOnFrmItem of addOnFrmData.entries()) {
        let addOnName = addOnFrmItem[0];
        let addOnValue = parseInt(addOnFrmItem[1]);
        let addOnPLU = addOnFormElem.elements[addOnName].dataset['plu'];

        if (addOnValue > 0) {
          extras.push({
            plu: addOnPLU,
            qty: addOnValue,
          });
          totalExtras += addOnValue;
        }
      }
    }

    //Parking
    function isParking(extra) {
      extra.plu === parkingPLU;
    }
    let index = extras.findIndex(isParking);
    if (index) {
      extras.splice(index, 1)
    }

    const parkingFormElem = document.getElementById('frm-parking');
    if (parkingFormElem) {
      const parkingFormData = new FormData(parkingFormElem);
      let parkingOption = parkingFormData.get('parking');
      if (parkingOption && '1' === parkingOption) {
        extras.push({
          plu: parkingPLU,
          qty: parkingFormData.get('qty-parking'),
        });
      }
    }

    // Refund Protection
    totalTicketsToProtect = 0;
    totalExtrasToProtect = totalExtras;
    visitors.forEach((visitorItem) => {
      if (ticketsProtectedPlus.includes(visitorItem.plu)) {
        totalTicketsToProtect += visitorItem.qty;
      }
    });

    const bookingProtectionFormElem = document.getElementById('frm-booking-protection');
    if (bookingProtectionFormElem) {
      const bookingProtectionFormData = new FormData(bookingProtectionFormElem);
      bookingProtectionFrmData = bookingProtectionFormData;
      totalTicketsProtected = totalExtrasProtected = 0;
      bookingProtection = [];

      let bookingProtectionOption = bookingProtectionFrmData.get('booking-protection');
      if (bookingProtectionOption && '1' === bookingProtectionOption) {
        if (totalTicketsToProtect > 0) {
          totalTicketsProtected = totalTicketsToProtect;
          bookingProtection.push({
            plu: ticketProtectionPLU,
            qty: totalTicketsProtected,
          });
        }
        if (totalExtrasToProtect > 0) {
          totalExtrasProtected = totalExtrasToProtect;
          bookingProtection.push({
            plu: addOnProtectionPLU,
            qty: totalExtrasProtected,
          });
        }
      }
    }
  };

  const updateAvailability = (DatePickerEl, setDate=false) => {
    // updateTicketSelections();
    let currentMonth = DatePickerEl.currentMonth + 1;
    let {currentYear} = DatePickerEl;

    if (setDate && arrivalDate) {
      const selectedDate = new Date(arrivalDate);
      currentMonth = selectedDate.getMonth() + 1;
      currentYear = selectedDate.getFullYear();
    }

    GalaxyApi.getAvailability(currentMonth, currentYear, totalVisitors).then(prices => {
      const availability = Object.keys(prices);
      if (Array.isArray(availability) && availability.length) {
        DatePickerEl.set('enable', availability);
        DatePickerEl.set('onDayCreate', (dObj, dStr, fp, dayElem) => {
          const eventDate = DatePickerEl.formatDate(dayElem.dateObj, "Y-m-d");
          if (eventDate in prices && 'GAADN001' in prices[eventDate] && 'lowest_price' in prices[eventDate]['GAADN001']) {
            let isLowestPrice = prices[eventDate]['GAADN001']['flags']['is_lowest_price_in_range'];
            dayElem.innerHTML += `<span class="from-price">from<span${isLowestPrice ? ' class="from-price--lowest"' : ''}> ${prices[eventDate]['GAADN001']['lowest_price']}</span></span>`;
            let flagsElem = document.createElement("span");
            flagsElem.classList.add('flags');
            if (isLowestPrice) {
              dayElem.classList.add('flatpickr-day--lowest-price');
              flagsElem.innerHTML += '<span class="flags__flag flags__flag--lowest_price"></span>';
            }
            let isAllDayEntry = prices[eventDate]['GAADN001']['flags']['is_all_day_entry'];
            if (isAllDayEntry) {
              dayElem.classList.add('flatpickr-day--all-day-entry');
              flagsElem.innerHTML += '<span class="flags--all-day-entry"></span>';
            }
            let isGondolaClosed = prices[eventDate]['flags']['is_gondola_closure'];
            if (isGondolaClosed) {
              dayElem.classList.add('flatpickr-day--gondola-closed');
              flagsElem.innerHTML += '<span class="flags__flag flags__flag--gondola_closed"></span>';
            }
            dayElem.appendChild(flagsElem);
          } else {
            dayElem.innerHTML += `<span class="from-price">&nbsp;</span>`;
          }
        });
        if (setDate && arrivalDate) {
          DatePickerEl.setDate(arrivalDate, false, 'Y-m-d');
        }
        DatePickerEl.redraw();
      } else {
        DatePickerEl.set('enable', ["1900-01-01"]);
      }
    });
  };

  const initDatePicker = (elem, defaultDate = null) => {
    const today = new Date();
    return flatpickr(elem, {
      // defaultDate,
      minDate: today,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d/m/Y",
      enable: ["1900-01-01"],
      appendTo: document.querySelector('#datepicker-placeholder'),
      position: "above center",
      positionElement: document.querySelector('#datepicker'),
      inline: true,
      wrap: true,
      ignoredFocusElements: [window.document.body],
      onMonthChange: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance);
        }
      ],
      onYearChange: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance);
        }
      ],
      onOpen: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance);
        }
      ],
      onReady: [
        (selectedDates, dateStr, instance) => {
          updateAvailability(instance, true);
        }
      ],
    });
  };

  const updateAddonCounters = () => {
    const inputCounters = document.querySelectorAll('.input-counter__input');
    let addonCount = 0;
    inputCounters.forEach((elem) => {
      addonCount += parseInt(elem.value, 10);
    });
    const submitBtn = document.getElementById('addonformSubmit');
    if (addonCount > 0) {
      submitBtn.value = `Add Selected Add-ons (${addonCount})`;
    } else {
      submitBtn.value = `No Thank You`;
    }
  };

  const isLateEntry = (someDate) => {
    const today = new Date()
    return someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear() &&
        today >= lateEntryStartTime
  }

  const showTickets = (scroll=false) => {
    DOM.buyTicketsComponent.innerHTML = TicketsTpl({
      visitors,
      visitorFrmData
    });

    // Init modules
    InputCounter.init();

    const formElem = document.getElementById('frm-ticket-selection');
    // Repopulate form data
    if (visitorFrmData instanceof FormData) {
      for (const visitorFrmItem of visitorFrmData.entries()) {
        let visitorFrmItemName = visitorFrmItem[0];
        let visitorFrmItemValue = visitorFrmItem[1];

        if (visitorFrmData.get(visitorFrmItemName)) {
          formElem.elements[visitorFrmItemName].value = visitorFrmItemValue;
        }
      }
    }

    // Display ticket component
    DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
    setTimeout(() => {
      DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
    }, 300);

    // On show tickets
    formElem.addEventListener("submit", (e) => {
      e.preventDefault();
      updateTicketSelections();

      let frmErrorMsg = '';
      let frmError = false;

      // Remove form errors
      document.querySelectorAll('.invalid-feedback').forEach((elem) => {
        elem.remove();
      });

      // Validate visitors
      if (totalVisitors < 1) {
        frmError = true;
        frmErrorMsg = 'Please specify the number of visitors in your booking';
      }

      const ticketFormElem = document.getElementById('frm-ticket-selection');
      if (ticketFormElem) {
        visitorFrmData = new FormData(ticketFormElem);

        for (const ticketFrmEntry of visitorFrmData.entries()) {
          let ticketFieldName = ticketFrmEntry[0];
          let ticketName = ticketFormElem.elements[ticketFieldName].dataset.name;
          let ticketQty = parseInt(ticketFrmEntry[1]);
          let orderLimit = parseInt(ticketFormElem.elements[ticketFieldName].dataset.orderLimit);

          if (ticketQty > orderLimit) {
            frmError = true;
            frmErrorMsg = `Quantity for "${ticketName}" has exceeded the allowable quantity of ${orderLimit} per order.`;
          }
        }
      }

      if (totalVisitors > 25) {
        frmError = true;
        frmErrorMsg = `Error: there is a maximum of 25 tickets per order`;
      }

      // Exit if form errors
      if (frmError) {
        document.getElementsByClassName('ticket-selection')[0]
            .insertAdjacentHTML(
                'afterend',
                `<p class="invalid-feedback" style="display:block">${frmErrorMsg}</p>`
            );
        return;
      }

      showArrivalDates();

    });
    if (scroll) {
      DOM.buyTicketsComponent.scrollIntoView();
    }
  };

  const showArrivalDates = () => {
    DOM.buyTicketsComponent.innerHTML = ArriveDateTpl({
      date,
      hasChildTicketInPackage: hasFromPriceTicketInPackage
    });

    const formElem = document.getElementById('frm-arrival-date');
    let selectedDate = arrivalDate ? arrivalDate : null;

    DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
    setTimeout(() => {
      DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
    }, 300);

    // Init modules
    initDatePicker('#datepicker', selectedDate);

    // On date selection
    formElem.addEventListener("submit", (e) => {
      e.preventDefault();
      updateTicketSelections();

      if (arrivalDate) {
        const dateParts = arrivalDate.split('-');
        date = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
      }

      let frmErrorMsg = '';
      let frmError = false;

      // Remove form errors
      document.querySelectorAll('.invalid-feedback').forEach((elem) => {
        elem.remove();
      });

      // Validate date
      if (!Date.parse(date)) {
        frmError = true;
        frmErrorMsg = 'Please select your admission date';
      }

      // Exit if form errors
      if (frmError) {
        document.getElementsByClassName('datepicker-input')[0]
            .insertAdjacentHTML(
                'afterend',
                `<p class="invalid-feedback" style="display:block">${frmErrorMsg}</p>`
            );
        return;
      }

      showArrivalTimes();

    });
    DOM.buyTicketsComponent.scrollIntoView();
  }

  const showArrivalTimes = () => {
    moment.locale('en-GB');
    const eventDate = moment(date).format('YYYY-MM-DD');
    GalaxyApi.getTimeslots(eventDate, visitors, extras).then(timeslots => {
      if ('all_day_entry' in timeslots) {
        // const earlyClosingDates = ['2023-06-27', '2023-06-28', '2023-06-29', '2023-06-30' ];
        // const day = date.getDay();
        // const isWeekend = (day === 6 || day === 0);
        // let entryTime = '10:00am - 4:00pm';
        // if (earlyClosingDates.includes(eventDate)) {
        //   entryTime = '10:00am - 3:30pm';
        // } else if (isWeekend) {
        //   entryTime = '10:00am - 5:00pm';
        // }
        const entryTime = '10:00am till close';
        DOM.buyTicketsComponent.innerHTML = ArrivalTimeAllDayTpl({
          date: moment(date).format('ddd MMM D, YYYY'),
          isLateEntryTime: isLateEntry(date),
          entryTimeText: entryTime,
          timeslots,
        });
      } else {
        DOM.buyTicketsComponent.innerHTML = ArrivalTimeTpl({
          date: moment(date).format('ddd MMM D, YYYY'),
          isLateEntryTime: isLateEntry(date),
          timeslots,
        });
      }

      const formElem = document.getElementById('frm-arrival-time');
      let selectedTime = arrivalTime ? arrivalTime : null;

      DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
      setTimeout(() => {
        DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
      }, 300);

      if (selectedTime) {
        let selectedTimeInput = document.querySelector(`input[name="time"][value="${selectedTime}"]`);
        if (selectedTimeInput) {
          selectedTimeInput.checked = true;
          selectedTimeInput.closest('.timeslot').classList.add('timeslot--active');
        }
      }

      formElem
          .querySelectorAll('input[name="time"]')
          .forEach((elem) => {
            elem.addEventListener(
                'change',
                (e) => {
                  document.querySelectorAll('.timeslot').forEach((timeslot) => {
                    timeslot.classList.remove('timeslot--active');
                  });
                  e.target.closest('.timeslot').classList.add('timeslot--active');

                  // eventId = e.target.getAttribute('data-event-id');

                  // document.querySelector('.preloader--timeslots')
                  //     .classList
                  //     .remove('preloader--disable');
                  // document.getElementById('frm-arrival-time').scrollIntoView();
                  // setTimeout(() => {
                  //   window.location.href = e.target.getAttribute('data-deeplink');
                  // }, 300);
                }
            );
          });

      // On show arrival times
      formElem.addEventListener("submit", (e) => {
        e.preventDefault();
        updateTicketSelections();

        let frmErrorMsg = '';
        let frmError = false;

        // Remove form errors
        document.querySelectorAll('.invalid-feedback').forEach((elem) => {
          elem.remove();
        });

        // Validate date
        if (!arrivalTime) {
          frmError = true;
          frmErrorMsg = 'Please select your admission time';
        }

        // Exit if form errors
        if (frmError) {
          document.getElementsByClassName('timeslot-picker')[0]
              .insertAdjacentHTML(
                  'afterend',
                  `<p class="invalid-feedback" style="display:block">${frmErrorMsg}</p>`
              );
          return;
        }

        if (skipAddons) {
          totalExtras = 0;
          extras = [];
          addOnFrmData = '';
          showParking();
        } else {
          showAddOns();
        }
      });
    });
    DOM.buyTicketsComponent.scrollIntoView();
  };

  const showAddOns = () => {
    GalaxyApi.getAddons(1).then(addOns => {
      DOM.buyTicketsComponent.innerHTML = AddOnTpl({
        addOns,
        addOnFrmData
      });

      // Init modules
      InputCounter.init();

      const formElem = document.getElementById('frm-addon');

      // Repopulate form data
      if (addOnFrmData instanceof FormData) {
        addOns.map((addOn) => {
          let addOnName = `addOn[${addOn.plu}]`;
          if (addOnFrmData.get(addOnName)) {
            formElem.elements[addOnName].value = addOnFrmData.get(addOnName);
          }
        });
      }

      // Update add-on selection count (previously selected)
      updateAddonCounters();

      // Add event listeners for add-on selection count
      const inputCounters = document.querySelectorAll('.input-counter__input');
      inputCounters.forEach((elem) => {
        elem.addEventListener('input', () => {
          updateAddonCounters();
        });
      });

      // Show tickets
      DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
      setTimeout(() => {
        DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
      }, 300);

      // On adding add-ons
      formElem.addEventListener("submit", (e) => {
        e.preventDefault();
        updateTicketSelections();
        showBookingProtection();
      });
    });
    DOM.buyTicketsComponent.scrollIntoView();
  };

  const showParking = () => {
    let parkingPrice = '$13.00';
    DOM.buyTicketsComponent.innerHTML = ParkingTpl({
      parkingPrice,
      parkingFrmData,
      skipAddons
    });

    // Init modules
    InputCounter.init();

    const formElem = document.getElementById('frm-parking');

    // Show parking
    DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
    setTimeout(() => {
      DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
    }, 300);

    // On parking form submit
    formElem.addEventListener("submit", (e) => {
      e.preventDefault();
      updateTicketSelections();

      let frmErrorMsg = '';
      let frmError = false;

      // Remove form errors
      document.querySelectorAll('.invalid-feedback').forEach((elem) => {
        elem.remove();
      });

      // Validate parking option
      let parkingFrmData = new FormData(formElem);
      let parkingOption = parkingFrmData.get('parking');
      if (! parkingOption) {
        frmError = true;
        frmErrorMsg = 'Please confirm if you would like to add parking to your booking';
      }

      if (frmError) {
        document.querySelector('.ticket-insurance__fieldset')
          .insertAdjacentHTML(
            'afterend',
            `<p class="invalid-feedback" style="display:block">${frmErrorMsg}</p>`
          );
        return;
      }

      document.querySelector('.preloader--timeslots')
        .classList
        .remove('preloader--disable');
      document.getElementById('frm-parking').scrollIntoView();
      setTimeout(() => {
        window.location.href = getDeeplink();
        // console.log(getDeeplink());
      }, 300);
    });

    DOM.buyTicketsComponent.scrollIntoView();
  };

  const showBookingProtection = () => {
    let calculateBookingProtectionPrice = function () {
      const ticketProtectionPrice = 2.00;
      const extraProtectionPrice = 0.79;
      let totalBookingProtectionPrice = ( totalTicketsToProtect * ticketProtectionPrice ) + ( totalExtrasToProtect * extraProtectionPrice );
      let formatting_options = {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2,
      }
      let formatter = new Intl.NumberFormat( 'en-GB', formatting_options );
      return formatter.format(totalBookingProtectionPrice);
    }


    let bookingProtectionTotalPrice = calculateBookingProtectionPrice();
    DOM.buyTicketsComponent.innerHTML = TicketInsuranceTpl({
      bookingProtectionTotalPrice,
      bookingProtectionFrmData
    });

    const formElem = document.getElementById('frm-booking-protection');

    // Repopulate form data - not working and not needed
    // if (bookingProtectionFrmData instanceof FormData) {
    //   let bookingProtectionOption = bookingProtectionFrmData.elements('booking-protection');
    //     if (bookingProtectionOption) {
    //       for( let i = 0; i < bookingProtectionOption.length; i++ ) {
    //         if(bookingProtectionOption[i].checked) {
    //           return bookingProtectionOption[i].value;
    //         }
    //       }
    //   }
    // }

    // Show booking protection
    DOM.buyTicketsComponent.querySelector('.hide').classList.add("show");
    setTimeout(() => {
      DOM.buyTicketsComponent.querySelector('.hide').classList.remove("hide");
    }, 300);

    // On booking protection form submit
    formElem.addEventListener("submit", (e) => {
      e.preventDefault();
      updateTicketSelections();

      let frmErrorMsg = '';
      let frmError = false;

      // Remove form errors
      document.querySelectorAll('.invalid-feedback').forEach((elem) => {
        elem.remove();
      });

      // Validate booking protection option
      let bookingProtectionFrmData = new FormData(formElem);
      let bookingProtectionOption = bookingProtectionFrmData.get('booking-protection');
      if (! bookingProtectionOption) {
        frmError = true;
        frmErrorMsg = 'Please confirm if you would like to add refund protection to your booking protection';
      }

      if (frmError) {
        document.querySelector('.ticket-insurance__fieldset')
          .insertAdjacentHTML(
            'afterend',
            `<p class="invalid-feedback" style="display:block">${frmErrorMsg}</p>`
          );
        return;
      }

      document.querySelector('.preloader--timeslots')
        .classList
        .remove('preloader--disable');
      document.getElementById('frm-booking-protection').scrollIntoView();
      setTimeout(() => {
        window.location.href = getDeeplink();
        // console.log(getDeeplink());
      }, 300);
    });

    DOM.buyTicketsComponent.scrollIntoView();
  };

  const getDeeplink = () => {
    let deeplinkData = {
      CG: 'gattix',
      C: 'OTix'
    };

    if (eventId) {
      deeplinkData.EventID = eventId;
    }

    let allItems = [ ...visitors, ...extras , ...bookingProtection ];
    let count = 0;

    allItems.forEach((item) => {
      count++;
      let pluKey = `PLU${count}`;
      let qtyKey = `QTY${count}`;
      deeplinkData[pluKey] = item.plu;
      deeplinkData[qtyKey] = item.qty;
    });

    const params = new URLSearchParams(deeplinkData);
    //Missing EventID!!!!
    return AppConfig.deeplink_base_url + '?' + params.toString();
  }

  const goToStep = (step) => {
    switch (step) {
      case "ga-tickets":
        showTickets(true);
        break;
      case "arrival-date":
        showArrivalDates();
        break;
      case "addon":
        showAddOns();
        break;
      case "arrival-time":
        showArrivalTimes();
        break;
      case "parking":
        showParking();
        break;
      case "booking-protection":
        showBookingProtection();
        break;
      default:
        showTickets(true);
        break;
    }
  };

  const init = () => {
    cacheDOM();
    if (DOM.buyTicketsComponent) {
      // showParking();
      showTickets();

      document.addEventListener('click', (e) => {
        if (e.target && e.target.matches('.js-progress-step, .js-progress-step *')) {
          e.preventDefault();
          let step = e.target.getAttribute("data-progress-step")
              ? e.target.getAttribute("data-progress-step")
              : e.target.closest('.js-progress-step').getAttribute("data-progress-step");
          goToStep(step);
        }
      });
    }
  };

  return {
    init
  };
})();

export default BuyTickets;


// const TicketSelection = (() => {
//
//   const populate = () => {}
//   const process = () => {}
//   const render = () => {}
//   const init = () => {}
//
//   return {
//     init,
//     render
//   };
// });
